import React, {useEffect, useState} from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import BBProfileCard from "../../../../../components/customBreachBits/BBProfileCard";
import {useHistory} from "react-router-dom";
import {HashLink as Link} from "react-router-hash-link";
import Banner from "../../../../../assets/images/BreachRisk_FAQ_Banner.svg";
import {BBBreachRiskSubscriptionBadge} from "../../../../../util/bbHelpers";
import {Button} from "@material-ui/core";
import BBExternalLink from "../../../../../components/customBreachBits/accents/BBExternalLink";
import BBIconQuestionHandRequest from "../../../../../assets/bbCustomIcons/BBIconQuestionHandRequest";
import {EarlyAccessChip} from "../../../../../components/customBreachBits/settings/EarlyAccessWrapper";

const FAQ = (props) => {

  const {location, match} = props;
  // const urlSection = location.search ? qs.parse(location.search, { ignoreQueryPrefix: true }).section : null;
  let urlSection = match.params.section
      ? match.params.section
      : null;
  let history = useHistory();

  // const [expanded, setExpanded] = useState(null);
  const [expanded, setExpanded] = useState(urlSection);


  // const handleChange = panel => (event, expanded) => {
  //   setExpanded(() => expanded ? panel : false)
  // };

  const handleChange = panel => (event, expanded) => {
    setExpanded(() => expanded ? panel : false);

    //enables full back button and history behavior
    if(expanded) {
      history.push(`/board/faq/${panel}`)
    } else {
      history.push(`/board/faq`)
    }
  };

  useEffect(() => {
    //enables full back button and history behavior
    setExpanded(urlSection);
  }, [match]);

  return (
    <div className="app-wrapper animated fadeIn animation-duration-7">
      <div style={{backgroundImage: `url(${Banner})`, margin: "auto", width: "auto", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>
      <hr/>
      <div className="row">
        <div className="col-lg-8 col-md-7 col-12 mb-4 mb-md-0">

          <Accordion expanded={expanded === 'TourYourService'} onChange={handleChange('TourYourService')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              How can I learn more about my Breachrisk&trade; service?
            </AccordionSummary>
            <AccordionDetails>
              <p>
                Learn about BreachRisk&trade; in multiple places throughout the application and in our <BBExternalLink tipText={"This link opens a separate tab to our knowledge base."} href={"https://support.breachbits.com/knowledge/"}>Knowledge Base.</BBExternalLink>
              <br/><br/>
                Visit the <Link to={`/board/userguide`}> Interactive User's Guide </Link>to get an overview of the services we provide and to learn about the processes that go into finding and determining your risk threats and scores.
              <br/><br/>
                Each page in the BreachRisk&trade; for Business solution has a tour available to walk you through what's available and most relevant in each section. If the tour doesn't start automatically, or you'd like to review it again, you can launch the page's tour by clicking the <BBIconQuestionHandRequest/> icon located in the top right.
              </p>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expanded === 'HowBRSWorks'} onChange={handleChange('HowBRSWorks')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              How is BreachRisk™ Score calculated?
            </AccordionSummary>
            <AccordionDetails>
              <p>BreachRisk™ Score is the world's only cyber risk score based on the hacker's perspective. BreachRisk™ Score answers this question: "How easy would it be for a malicious hacker to breach this company?" With this question as our guiding principle, BreachRisk™ Score uses safe, advanced attack planning and testing techniques to discover and test threats in a company's cyberspace. These are the same techniques that advanced hackers use, and we conduct these activities in an ethical manner.</p>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === 'HowBRSWorksUp'} onChange={handleChange('HowBRSWorksUp')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              What caused my BreachRisk™ Score to go up?
            </AccordionSummary>
            <AccordionDetails>
              <p>A higher score indicates higher risk. When it becomes easier for malicious hackers to breach your cyberspace, your BreachRisk™ Score will go up. This is a bad thing. This usually means that we found or validated a way to cause a breach, something changed on your defenses, or hackers discovered a new way to cause a breach.</p>
            </AccordionDetails>
          </Accordion>
          <Accordion expanded={expanded === 'HowBRSWorksDown'} onChange={handleChange('HowBRSWorksDown')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              What caused my BreachRisk™ Score to go down?
            </AccordionSummary>
            <AccordionDetails>
              <p>A lower score indicates lower risk. When it becomes harder for malicious hackers to breach your cyberspace, your BreachRisk™ Score will go down. This is a good thing. This usually means that we lost a way to cause a breach or you defeated more of our attack-based testing, something improved on your defenses, or hacker tools and methods became weaker.</p>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expanded === 'WhoCanSeeBRScore'} onChange={handleChange('WhoCanSeeBRScore')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              Who can see my BreachRisk™ Score?
            </AccordionSummary>
            <AccordionDetails>
              <p>BreachRisk™ Score is public information. Anybody with a BreachRisk™ Portfolio account can see your BreachRisk™ Score.
                <br/><br/>
                BreachRisk™ Score includes the 10-point risk score, the risk category, the fidelity category, the highest possible risk score, the lowest possible risk score, the relative size if your IT infrastructure, and whether you have provided attestations within the past 90 days, have penetration testing enabled, and have a registered BreachRisk™ for Business account.
              </p>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expanded === 'WhoCanSeeBRReport'} onChange={handleChange('WhoCanSeeBRReport')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              Who can see my BreachRisk™ Report?
            </AccordionSummary>
            <AccordionDetails>
              <p>BreachRisk™ Report is not public, but we help you safely share it with stakeholders if you so choose. You can share your BreachRisk™ Report with the Data Sharing function within a BreachRisk™ for Business subscription. If you have a BreachRisk™ Portfolio subscription, you can request access to a company's BreachRisk™ Report using the Manage Portfolio function.

                <br/><br/>
                You can revoke access to your BreachRisk™ Report at any time.
              </p>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expanded === 'WhoCanSeeBRTechnical'} onChange={handleChange('WhoCanSeeBRTechnical')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              Who can see my BreachRisk™ Technical?
            </AccordionSummary>
            <AccordionDetails>
              <p>BreachRisk™ Technical is not public - and this information is extremely sensitive. We only help you share it in special circumstances (e.g. with your Manage Security Service Provider) with your explicit permission. If you think you need to share BreachRisk™ Technical, please <span className="text-primary jr-link"><Link href={"mailto:support@breachbits.com?subject=Share my BreachRisk™ Technical (from BreachBoard)"}>contact support@breachbits.com</Link></span>.

                <br/><br/>
                In the rare circumstance that you are sharing BreachRisk™ Technical, you can revoke access at any time.
              </p>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expanded === 'WhatIsFidelity'} onChange={handleChange('WhatIsFidelity')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              What is "Fidelity" in BreachRisk™ Score?
            </AccordionSummary>
            <AccordionDetails>
              <p>
                Fidelity is a core part of BreachRisk™ Score. It characterizes the degree of confidence in the 10-point number within BreachRisk™ Score. As we gain more clarity on where your company exists in cyberspace and have more opportunities to test and interact with your systems, the better Fidelity becomes.
                <br/><br/>
                We provide the hacker's perspective, so imagine being inside the mind of a hacker. As we have doubts that could mean your risk is higher, Fidelity decreases. As we find reasons that your risk could be lower, Fidelity also decreases. But when Fidelity is high, it means that we are very confident that your 10-point score is the actual risk of a cyber breach.
                <br/><br/>
                To increase Fidelity: provide Verifications and Attestations, enable Penetration Testing, keep Threat Vectors "in-scope", and provide Cloud Integrations.
              </p>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expanded === 'EnablePenTesting'} onChange={handleChange('EnablePenTesting')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              How do I enable Penetration Testing with my BreachRisk™ service?
            </AccordionSummary>
            <AccordionDetails>
              <p><BBBreachRiskSubscriptionBadge subscriptionLevel={"Premium"}/> and <BBBreachRiskSubscriptionBadge subscriptionLevel={"Pro"}/> BreachRisk™ for Business subscriptions include the Penetration Testing feature and gives you access to the Penetration Testing control button on your <Link to="/board/BreachRisk/Business/Score">BreachRisk Score</Link> page or your <Link to="/board/settings/account">Account Settings</Link> page.<br/>
                <br/>
                You can also download a Certified BreachRisk™ Penetration Test Report reports for use with compliance, regulations, and insurance and other stakeholders.</p>
            </AccordionDetails>
          </Accordion>

          {/*<Accordion expanded={expanded === 'WhatIsCertifiedPenTest'} onChange={handleChange('WhatIsCertifiedPenTest')}>*/}
          {/*  <AccordionSummary expandIcon={<ExpandMoreIcon/>}>*/}
          {/*    What is a Certified BreachRisk™ Penetration Test Report?*/}
          {/*  </AccordionSummary>*/}
          {/*  <AccordionDetails>*/}
          {/*    <p>A Certified BreachRisk™ Penetration Test Report is a downloadable document in traditional penetration test format that proves that your external attack surface has been thoroughly tested by BreachRisk™.*/}
          {/*      <br/><br/>*/}
          {/*      Certified BreachRisk™ Penetration Test Reports are perfect for use with certifications, regulations, insurance applications and other stakeholders.*/}
          {/*      <br/><br/>*/}
          {/*      These reports include technical details required to prove these activities to others and guarantees that we have performed certain benchmark activities. Assembling these reports and providing these additional guarantees means that these reports are only available in <BBBreachRiskSubscriptionBadge subscriptionLevel={"Premium"}/> and  <BBBreachRiskSubscriptionBadge subscriptionLevel={"Pro"}/> BreachRisk™ for Business subscriptions.*/}

          {/*    </p>*/}
          {/*  </AccordionDetails>*/}
          {/*</Accordion>*/}

          {/*<Accordion expanded={expanded === 'OrderCertifiedPenTest'} onChange={handleChange('OrderCertifiedPenTest')}>*/}
          {/*  <AccordionSummary expandIcon={<ExpandMoreIcon/>}>*/}
          {/*    How do I download a Certified BreachRisk™ Penetration Test Report?*/}
          {/*  </AccordionSummary>*/}
          {/*  <AccordionDetails>*/}
          {/*    <p>If your subscription includes the Penetration Testing feature, you have access to BreachRisk™ Penetration Test Reports.*/}
          {/*      <br/>*/}
          {/*      <BBBreachRiskSubscriptionBadge subscriptionLevel={"Premium"}/> level BreachRisk™ for Business subscriptions have access to on-demand reports as a part of the subscription. <BBBreachRiskSubscriptionBadge subscriptionLevel={"Pro"}/> level BreachRisk™ for Business subscriptions allow you to purchase a Certified BreachRisk™ Penetration Test Report.</p>*/}
          {/*  </AccordionDetails>*/}
          {/*</Accordion>*/}

          <Accordion expanded={expanded === 'HowItWorks'} onChange={handleChange('HowItWorks')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              How do BreachBits services work?
            </AccordionSummary>
            <AccordionDetails>
              <p>BreachBits uses automation and AI methods to emulate malicious hackers continuously from the cloud.  Our breach engine conducts periods of reconnaissance followed by periods of analysis and attack campaigns.</p>
            </AccordionDetails>
          </Accordion>

          <Accordion expanded={expanded === 'EarlyAccessProgram'} onChange={handleChange('EarlyAccessProgram')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              What is the Early Access program? <EarlyAccessChip/>
            </AccordionSummary>
            <AccordionDetails>
              <p>You or your company may be invited to participate in the Early Access program. Some features are in Early Access during final evaluation or during limited-duration experiments. If you would like to be a part of the Early Access program, contact support@breachbits.com.</p>
            </AccordionDetails>
          </Accordion>

          {/*<Accordion expanded={expanded === 'SafetyPromise'} onChange={handleChange('SafetyPromise')}>*/}
          {/*  <AccordionSummary expandIcon={<ExpandMoreIcon/>}>*/}
          {/*    Are my data and services safe with BreachBits?*/}
          {/*  </AccordionSummary>*/}
          {/*  <AccordionDetails>*/}
          {/*    <p>Our services will always be safe and confidential. We will never destroy, manipulate, or unnecessarily exfiltrate your data, and we will never disrupt your services without your explicit request and consent. You will always know if BreachBits is actively engaging your systems and you will have the control to stop and start our services in real time. You will have access to the technical information that we discover and generate. We will provide analytical insights to help you lead your team and manage your risks.</p>*/}
          {/*  </AccordionDetails>*/}
          {/*</Accordion>*/}

          <Accordion expanded={expanded === 'GettingHelp'} onChange={handleChange('GettingHelp')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              What if I need some help?
            </AccordionSummary>
            <AccordionDetails>
              <p>You can always use our <Link to="/board/contact" >Contact</Link> page to ask questions or provide feedback.  We will
              work diligently to ensure your concerns are addressed promptly.</p>
            </AccordionDetails>

          </Accordion>

          <Accordion expanded={expanded === 'HowWeUpdate'} onChange={handleChange('HowWeUpdate')}>
            <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
              How frequently does your service, technology, and process update?
            </AccordionSummary>
            <AccordionDetails>
              <p>Due to the nature of our approaches to automation, artificial intelligence, and continuous
              development/continuous improvement, our services are constantly being updated, tweaked, and trying out
              new things.  Just like real malicious hackers, we approach many tasks in a similar way, but
              the exact methods, actions, and outcomes are rarely identical.</p>
            </AccordionDetails>
          </Accordion>

          {/*<Accordion expanded={expanded === 'StoppingService'} onChange={handleChange('StoppingService')}>*/}
          {/*  <AccordionSummary expandIcon={<ExpandMoreIcon/>}>*/}
          {/*    How do I stop my CIRT service?*/}
          {/*  </AccordionSummary>*/}
          {/*  <AccordionDetails>*/}
          {/*    <p>Some elements of the CIRT service will always operate while your subscription is active.  However,*/}
          {/*    you are in control of some the "active" parts of the service that legally require your consent.  Your*/}
          {/*    consent allows us to conduct these activities which would otherwise violate international law*/}
          {/*    or precedent.<br/>*/}
          {/*      <br/>*/}
          {/*      You can start or stop external attack activity by toggling the "Continuous Perimeter Attacks" button on your <Link to="/board/CIRT/external">External Threat module</Link> page or from the <Link to={"/board/userguide/HowUseBreachBoard"}>Interactive User's Guide</Link>.</p>*/}
          {/*  </AccordionDetails>*/}
          {/*</Accordion>*/}

        </div>

        <div className="col-lg-4 col-md-5 col-12 animation slideInRight">
          <div className="sidebar">

            {/*<div className="card shadow border-0 bg-white p-2">*/}
            {/*  <form className="m-0" role="search">*/}
            {/*    <div className="search-bar">*/}
            {/*      <div className="form-group">*/}
            {/*        <input type="search" className="form-control form-control-lg border-0"*/}
            {/*               placeholder="Search..."/>*/}
            {/*        <button className="search-icon">*/}
            {/*          <i className="zmdi zmdi-search zmdi-hc-lg"/>*/}
            {/*        </button>*/}
            {/*      </div>*/}
            {/*    </div>*/}
            {/*  </form>*/}
            {/*</div>*/}
            <BBProfileCard
              name={"J. Foster Davis"}
              title={"Co-Founder"}
              description={"I hope this collection of frequently asked questions is helpful.  Contact me for any feedback or problems!"}
              imgSrc={"https://static.wixstatic.com/media/8f3a1e_94fb4a162a884985963d5e427a8a3cd7~mv2.jpg"}
            />

          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;

